import { Stack } from 'shared/mui/Stack/Stack';
import { TooltipProps, TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';

type Props = { title: string; tooltipText: string } & Pick<TooltipProps, 'componentsProps'>;

export const GatewayRuleCardTitle: React.FC<Props> = ({ title, tooltipText, componentsProps }) => {
  return (
    <Stack alignItems="center" direction="row" gap="4px" mb={2}>
      <Typography component="h2" variant="h6">
        {title}
      </Typography>
      <TooltipWithInfoIcon
        componentsProps={componentsProps}
        iconSize={24}
        placement="right"
        tooltipText={tooltipText}
      />
    </Stack>
  );
};
